import React from "react";
import "./styles.css";
import homeImage from "../../../assets/images/dev.svg";
import Typewriter from "./Typewriter";
import { FaGithub, FaLinkedin, FaCode } from 'react-icons/fa';

const PageIntro = ({ reff }) => {
  const words = [
    "Hi, I'm Isuru Rangana!",
    "Backend Developer",
    "MERN Stack Developer"
  ];

  return (
    <section ref={reff} className="intro-section">
      <div className="container">
        <div className="row align-items-center min-vh-100">
          <div id="intro-section" className="col-lg-6">
            <div className="intro-content">
        
              
              <h1 className="display-4 fw-bold text-gradient mb-4">
                <Typewriter words={words} typingSpeed={100} delay={2000} />
              </h1>
              
              <p className="lead mb-4 text-muted">
                Passionate Backend Developer specializing in Spring Boot and MERN Stack development.
                Building robust and scalable server-side solutions.
              </p>

              <div className="tech-stack mb-4">
                <span className="tech-badge">Spring Boot</span>
                <span className="tech-badge">Java</span>
                <span className="tech-badge">Node.js</span>
              
                <span className="tech-badge">React.js</span>
              </div>

              <div className="cta-buttons mb-4">
                <a href="#projects" 
                   onClick={(e) => {
                     e.preventDefault();
                     document.querySelector('#projects').scrollIntoView({ behavior: 'smooth' });
                   }}
                   className="btn btn-primary btn-lg me-3 rounded-pill">
                  <FaCode className="me-2" />
                  View Projects
                </a>
              </div>

              <div className="social-links">
                <a href="https://github.com/Isuru-rangana" 
                   target="_blank" 
                   rel="noopener noreferrer" 
                   className="social-icon me-3 github-icon">
                  <FaGithub size={24} />
                  <span className="social-text">GitHub</span>
                </a>
                <a href="https://www.linkedin.com/in/isuru-rangana01" 
                   target="_blank" 
                   rel="noopener noreferrer" 
                   className="social-icon me-3 linkedin-icon">
                  <FaLinkedin size={24} />
                  <span className="social-text">LinkedIn</span>
                </a>
              </div>
            </div>
          </div>
          
          <div className="col-lg-6 d-none d-lg-block">
            <div className="animation-container">
              <div className="floating-shape"></div>
              <div className="floating-shape-2"></div>
              <img 
                className="img-fluid floating-image" 
                src={homeImage} 
                alt="Developer illustration" 
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageIntro;



/*

import React, { useState, useEffect } from "react";
import "./styles.css";
import homeImage from "../../../assets/images/dev.svg";
import Typewriter from "typewriter-effect";

const PageIntro = ({ reff }) => {
  const [role, setRole] = useState("Hi I'm Isuru");

  useEffect(() => {
    const roles = [ "Hi I'm Isuru","Full Stack Developer", "UI/UX Developer"];
    let currentIndex = 0;

    const interval = setInterval(() => {
      currentIndex = (currentIndex + 1) % roles.length;
      setRole(roles[currentIndex]);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section ref={reff}>
      <div className="container">
        <div className="row">
          <div id="intro-section" className="col">
            <div className=" rgba-gradient d-flex justify-content-center align-items-center header">
              <div className="container px-md-3 px-sm-0">
                <div className="row">
                  <div className="col-md-12 mb-4 text-center">
                    <h3 className="display-3 fw-bold pt-md-5 pt-5" style={{ color: "#2A083F" }}>
                      <Typewriter
                        options={{
                          strings: [role],
                          autoStart: true,
                          loop: true,
                        }}
                      />
                    </h3>
                    <hr className="my-4 text-light" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col d-none d-lg-inline">
            <div className=" rgba-gradient d-flex justify-content-center align-items-center header">
              <div className="container px-md-3 px-sm-0">
                <div className="row">
                  <div className="col-md-12 mb-4 mt-3 ms-5 text-center dev-img">
                    <img className="img-fluid mt-3 ms-5" src={homeImage} alt="home" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageIntro;
*/